export default __webpack_public_path__ + "static/logo2-82178ed67414a0040d414798655ed4cd.png";